
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"29","viewBox":"0 0 32 29","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M19.0789 0.145983C18.5965 -0.0925835 18.0195 -0.0375298 17.5939 0.274442L6.62134 8.25724H3.31067C1.48507 8.25724 0 9.69781 0 11.4687V16.9741C0 18.745 1.48507 20.1856 3.31067 20.1856H6.62134L17.5939 28.1683C17.8398 28.3519 18.1425 28.4436 18.4452 28.4436C18.6627 28.4436 18.8803 28.3977 19.0789 28.2968C19.5613 28.0674 19.864 27.5903 19.864 27.0673V1.37552C19.864 0.852506 19.5613 0.375373 19.0789 0.145983ZM2.83772 16.9741V11.4687C2.83772 11.2118 3.04582 11.0099 3.31067 11.0099H5.67544V17.4329H3.31067C3.04582 17.4329 2.83772 17.231 2.83772 16.9741ZM17.0263 24.3146L8.51315 18.121V10.3218L17.0263 4.1282V24.3146Z"}}),_c('path',{attrs:{"d":"M29.9096 14.2224L31.5839 12.5983C32.1419 12.057 32.1419 11.1853 31.5839 10.6531C31.0258 10.1117 30.1272 10.1117 29.5785 10.6531L27.9043 12.2772L26.23 10.6531C25.6719 10.1117 24.7733 10.1117 24.2247 10.6531C23.6761 11.1945 23.6666 12.0661 24.2247 12.5983L25.899 14.2224L24.2247 15.8465C23.6666 16.3879 23.6666 17.2595 24.2247 17.7917C24.499 18.0578 24.8679 18.1955 25.2274 18.1955C25.5868 18.1955 25.9557 18.0578 26.23 17.7917L27.9043 16.1676L29.5785 17.7917C29.8529 18.0578 30.2218 18.1955 30.5812 18.1955C30.9406 18.1955 31.3095 18.0578 31.5839 17.7917C32.1419 17.2504 32.1419 16.3787 31.5839 15.8465L29.9096 14.2224Z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('rect',{attrs:{"width":"32","height":"29"}})])])])
          )
        }
      }
    